import { Box, Typography, ButtonBase } from "@mui/material"
import { FC } from "react"
import { Container, SvgIcon } from ".."
import { navigate } from "gatsby"

interface WishlistHeaderProps {
  title: string
}

const WishlistHeader: FC<WishlistHeaderProps> = ({ title }) => {
  return (
    <Container maxWidth={1450}>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        gap={{ xs: 4, md: 0 }}
        justifyContent="space-between"
        mt={{ xs: 25, md: 60 }}
        px={{ xs: 0, md: 5 }}
        sx={(theme) => ({
          borderBottom: `2px solid ${theme.palette["neutral.200"].main}`,
          paddingBottom: { xs: theme.spacing(6.5), md: theme.spacing(20) },
        })}
      >
        <Typography variant="heading.2xl" component="h1" fontWeight={800} fontSize={56}>
          {title}
        </Typography>

        <BackCTA />
      </Box>
    </Container>
  )
}

export default WishlistHeader

const BackCTA: FC = () => {
  const handleBack = () => {
    const prevUrl = document.referrer
    if (prevUrl) {
      window.location.href = prevUrl // Forces a full refresh
    } else {
      navigate("/", { replace: true }) // Fallback to homepage
    }
  }

  return (
    <ButtonBase
      onClick={handleBack}
      sx={(theme) => ({
        ...theme.typography["link.md"],
        "display": "flex",
        "alignItems": "center",
        "gap": 2,
        "minHeight": 44,
        "padding": theme.spacing(2, 4),
        "backgroundColor": theme.palette["primary.800"].main,
        "borderRadius": 1,
        "lineHeight": 1,
        "transition": theme.transitions.create(["background-color", "border-color", "color"]),
        "&:hover": {
          backgroundColor: theme.palette["primary.900"].main,
        },
      })}
    >
      <SvgIcon
        viewBox="0 0 17 16"
        variant="arrowRight"
        strokeMode
        size={14}
        sx={(theme) => ({
          transform: "rotate(180deg)",
          stroke: theme.palette["neutral.100"].main,
        })}
      />
      <Typography
        variant="body.md"
        fontWeight={600}
        sx={(theme) => ({
          color: theme.palette["neutral.100"].main,
          whiteSpace: "nowrap",
          lineHeight: 1,
        })}
      >
        Back to Browsing
      </Typography>
    </ButtonBase>
  )
}
